module.exports = __webpack_public_path__ + "img/4-ton-drop-side-truck+-labour-canopy.404a86c8.jpg";